import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdCropImageAssetCacheKeys: AllRouteEndpoints[] = [
  "/engagement/media_library_data",
  "/engagement/:app_group_id/feature_limitations",
];
